import { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

import classNames from 'classnames';

import { FormInputSize } from '../types';

import style from './input.module.scss';

export interface InputProps
  extends Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'size' | 'ref'
  > {
  highlighted?: boolean;
  size?: FormInputSize;
  autoFocus?: boolean;
}

export const Input = forwardRef(function Input(
  { highlighted, size = 'small', autoFocus = false, ...props }: InputProps,
  ref?: React.ForwardedRef<HTMLInputElement>,
) {
  const internalRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => internalRef.current!);

  useEffect(() => {
    if (autoFocus && internalRef.current) {
      internalRef.current.focus();
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      draggable={false}
      ref={internalRef}
      {...props}
      className={classNames(
        {
          [style.input]: true,
          [style.sizeSmall]: size === 'small',
          [style.sizeMedium]: size === 'regular',
          [style.sizeLarge]: size === 'large',
          [style.highlighted]: highlighted,
        },
        props.className,
      )}
    />
  );
});
